/**
 * Titles and federation remotes from arq-embedded when src/apps/embed is mounted.
 * Without a mount, resolves to embed-apps.manifest.stub.json (empty list).
 */
import manifestJson from '@embed-manifest'
import type { EmbedManifest, EmbeddedAppManifestEntry } from './embedManifest.types'

const manifest = manifestJson as EmbedManifest

export const embeddedAppTitles: Record<string, string> = Object.fromEntries(
  manifest.embeddedApps.map((app) => [app.appKey, app.title])
)

export const embeddedAppDefaultPages: Record<string, string> = Object.fromEntries(
  manifest.embeddedApps.map((app) => [app.appKey, app.defaultPage])
)

export const embeddedAppsByKey: Record<string, EmbeddedAppManifestEntry> = Object.fromEntries(
  manifest.embeddedApps.map((app) => [app.appKey, app])
)
